// source: pbtypes/vehicle/dted/dted.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

goog.exportSymbol('proto.dted.CurrentTerrainHeight', null, global);
goog.exportSymbol('proto.dted.CurrentTerrainHeightStatus', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dted.CurrentTerrainHeight = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.dted.CurrentTerrainHeight, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dted.CurrentTerrainHeight.displayName = 'proto.dted.CurrentTerrainHeight';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dted.CurrentTerrainHeight.prototype.toObject = function(opt_includeInstance) {
  return proto.dted.CurrentTerrainHeight.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dted.CurrentTerrainHeight} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dted.CurrentTerrainHeight.toObject = function(includeInstance, msg) {
  var f, obj = {
utime: jspb.Message.getFieldWithDefault(msg, 1, 0),
status: jspb.Message.getFieldWithDefault(msg, 2, 0),
absoluteHeight: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
heightRelativeToNavOrigin: (f = jspb.Message.getOptionalFloatingPointField(msg, 5)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dted.CurrentTerrainHeight}
 */
proto.dted.CurrentTerrainHeight.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dted.CurrentTerrainHeight;
  return proto.dted.CurrentTerrainHeight.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dted.CurrentTerrainHeight} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dted.CurrentTerrainHeight}
 */
proto.dted.CurrentTerrainHeight.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUtime(value);
      break;
    case 2:
      var value = /** @type {!proto.dted.CurrentTerrainHeightStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAbsoluteHeight(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setHeightRelativeToNavOrigin(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dted.CurrentTerrainHeight.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dted.CurrentTerrainHeight.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dted.CurrentTerrainHeight} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dted.CurrentTerrainHeight.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUtime();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getAbsoluteHeight();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeDouble(
      5,
      f
    );
  }
};


/**
 * optional int64 utime = 1;
 * @return {number}
 */
proto.dted.CurrentTerrainHeight.prototype.getUtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.dted.CurrentTerrainHeight} returns this
 */
proto.dted.CurrentTerrainHeight.prototype.setUtime = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional CurrentTerrainHeightStatus status = 2;
 * @return {!proto.dted.CurrentTerrainHeightStatus}
 */
proto.dted.CurrentTerrainHeight.prototype.getStatus = function() {
  return /** @type {!proto.dted.CurrentTerrainHeightStatus} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.dted.CurrentTerrainHeightStatus} value
 * @return {!proto.dted.CurrentTerrainHeight} returns this
 */
proto.dted.CurrentTerrainHeight.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional double absolute_height = 3;
 * @return {number}
 */
proto.dted.CurrentTerrainHeight.prototype.getAbsoluteHeight = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.dted.CurrentTerrainHeight} returns this
 */
proto.dted.CurrentTerrainHeight.prototype.setAbsoluteHeight = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional double height_relative_to_nav_origin = 5;
 * @return {number}
 */
proto.dted.CurrentTerrainHeight.prototype.getHeightRelativeToNavOrigin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.dted.CurrentTerrainHeight} returns this
 */
proto.dted.CurrentTerrainHeight.prototype.setHeightRelativeToNavOrigin = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.dted.CurrentTerrainHeight} returns this
 */
proto.dted.CurrentTerrainHeight.prototype.clearHeightRelativeToNavOrigin = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.dted.CurrentTerrainHeight.prototype.hasHeightRelativeToNavOrigin = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * @enum {number}
 */
proto.dted.CurrentTerrainHeightStatus = {
  CURRENT_TERRAIN_HEIGHT_STATUS_INVALID: 0,
  CURRENT_TERRAIN_HEIGHT_STATUS_SUCCESS: 1,
  CURRENT_TERRAIN_HEIGHT_STATUS_OUT_OF_BOUNDS: 2,
  CURRENT_TERRAIN_HEIGHT_STATUS_FAILURE: 3
};

goog.object.extend(exports, proto.dted);
